import { defineComponent, ref, computed, watch } from "vue";
import Input from "../common/base/Input/index.mjs";
import Checkbox from "../common/base/Checkbox/index.mjs";
import TuiButton from "../common/base/Button.vue.mjs";
import Avatar from "../common/Avatar.vue.mjs";
import SearchIcon from "../common/icons/SearchIcon.vue.mjs";
import CloseIcon from "../common/icons/CloseIcon.vue.mjs";
import PanelContainer from "./PanelContainer.vue.mjs";
import { useI18n } from "../../locales/index.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "Contacts",
  props: {
    visible: { type: Boolean },
    contacts: null,
    selectedList: null,
    isMobile: { type: Boolean, default: false },
    disabledList: null
  },
  emits: ["input", "confirm"],
  setup(__props, { emit }) {
    const props = __props;
    const { t } = useI18n();
    const isDialogVisible = ref(false);
    const searchValue = ref("");
    const updateContacts = () => {
      contacts.value = props.contacts.map((user) => {
        var _a, _b;
        const index = (_a = props.selectedList) == null ? void 0 : _a.findIndex(
          (selectedUser) => selectedUser.userId === user.userID
        );
        const disableUserIndex = (_b = props.disabledList) == null ? void 0 : _b.findIndex(
          (disableUser) => disableUser.userId === user.userID
        );
        return {
          selected: index !== void 0 && index !== -1,
          disabled: disableUserIndex !== void 0 && disableUserIndex !== -1,
          userInfo: user
        };
      });
    };
    const updateVisible = (val) => {
      updateContacts();
      emit("input", val);
    };
    const contacts = ref(
      props.contacts.map((user) => {
        var _a, _b;
        const index = (_a = props.selectedList) == null ? void 0 : _a.findIndex(
          (selectedUser) => selectedUser.userId === user.userID
        );
        const disableUserIndex = (_b = props.disabledList) == null ? void 0 : _b.findIndex(
          (disabledUser) => disabledUser.userId === user.userID
        );
        return {
          selected: !!index && index !== -1,
          disabled: !!disableUserIndex && disableUserIndex !== -1,
          userInfo: user
        };
      })
    );
    const selectedContacts = computed(
      () => contacts.value.filter((user) => user.selected)
    );
    const searchResult = ref([]);
    const showList = computed(
      () => searchValue.value ? searchResult.value : contacts.value
    );
    const searchContact = (v) => {
      if (!v) return [];
      searchResult.value = contacts.value.filter(
        (item) => item.userInfo.profile.nick.includes(v) || item.userInfo.userID.includes(v)
      );
    };
    const removeSelectUser = (user) => {
      const index = contacts.value.findIndex(
        (item) => user.userInfo.userID === item.userInfo.userID
      );
      contacts.value[index].selected = false;
    };
    const confirm = () => {
      emit(
        "confirm",
        selectedContacts.value.map((item) => {
          const { userID, profile } = item.userInfo;
          return {
            userId: userID,
            userName: profile.nick,
            avatarUrl: profile.avatar
          };
        })
      );
      updateVisible(false);
    };
    const cancel = () => {
      updateVisible(false);
    };
    watch(
      () => props.visible,
      (val) => {
        isDialogVisible.value = val;
      },
      {
        immediate: true
      }
    );
    watch(
      isDialogVisible,
      (val) => {
        searchValue.value = "";
        updateVisible(val);
      },
      { immediate: true }
    );
    return { __sfc: true, t, props, emit, isDialogVisible, searchValue, updateContacts, updateVisible, contacts, selectedContacts, searchResult, showList, searchContact, removeSelectUser, confirm, cancel, TuiInput: Input, TuiCheckbox: Checkbox, TuiButton, TuiAvatar: Avatar, SearchIcon, CloseIcon, PanelContainer };
  }
});
export {
  _sfc_main as default
};
